import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import VueI18n from 'vue-i18n'
import messages from '@/messages'
import vueAwesomeCountdown from 'vue-awesome-countdown'
import VueCarousel from 'vue-carousel'

import './sass/main.scss'
// import VuetifyDialog from 'vuetify-dialog'
// import 'vuetify-dialog/dist/vuetify-dialog.css'

// import VEmojiPicker from 'v-emoji-picker'

import '@/plugins/global'

const DEFAULT_TITLE = 'Champion Moving Co., Ltd'

router.afterEach((to, from) => {
  // Use next tick to handle router history correctly
  // see: https://github.com/vuejs/vue-router/issues/914#issuecomment-384477609
  Vue.nextTick(() => {
    document.title = to.meta.title || DEFAULT_TITLE
  })
})

Vue.use(require('vue-moment'))
Vue.use(vueAwesomeCountdown, 'vac') // Component name, `countdown` and `vac` by default

Vue.use(VueCarousel)

// Vue.use(VuetifyDialog, {
//   context: {
//     vuetify
//   }
// })
// Vue.use(VEmojiPicker)

Vue.use(VueI18n)
Vue.config.productionTip = false

Vue.prototype.$bus = new Vue()

const i18n = new VueI18n({
  locale: 'en', // set locale
  messages // set locale messages
})

router.beforeEach((to, from, next) => {
  if (to.query.lang && i18n.locale !== to.query.lang) {
    i18n.locale = to.query.lang
  }
  next()
})

new Vue({
  i18n,
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
